module.exports = __webpack_public_path__ + "img/placement_body_back.705b6a94.png";